module.exports = __webpack_public_path__ + "static/img/model2-2.ae616061.jpg";